// Nidovela — scripts propios (prefijo mt-)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initContadores();
  initGaleriaProducto();
  initVariantes();
  initParallax();
  initBarraCompra();
  initBotonCompra();
});

function initBotonCompra() {
  var boton = document.querySelector('[data-mt-boton-comprar]');
  if (!boton || !boton.form) return;
  var textoOriginal = boton.textContent.trim();
  var form = boton.form;
  var enviandoNormal = false;

  function restaurar() {
    boton.classList.remove('mt-cargando');
    boton.textContent = textoOriginal;
    boton.disabled = false;
  }

  form.addEventListener('submit', function (e) {
    // Confirmación inmediata de que el clic se registró mientras carga el carrito.
    boton.classList.add('mt-cargando');
    boton.textContent = 'Añadiendo…';
    if (enviandoNormal) return;

    // Con el carrito lateral activo, añadimos sin salir de la página y lo abrimos.
    // Si algo falla, el formulario se envía como siempre y llega al carrito.
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.routes || !window.fetch) return;
    e.preventDefault();
    boton.disabled = true;

    var datos = new FormData(form);
    datos.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    datos.append('sections_url', window.location.pathname);
    if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(boton);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: datos
    })
      .then(function (r) { return r.json(); })
      .then(function (respuesta) {
        if (respuesta.status) throw new Error(respuesta.description || 'error');
        drawer.renderContents(respuesta);
        restaurar();
      })
      .catch(function () {
        enviandoNormal = true;
        boton.disabled = false;
        form.submit();
      });
  });
  // Si el cliente vuelve atrás desde el carrito, el botón no debe quedarse en "Añadiendo…".
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      boton.classList.remove('mt-cargando');
      boton.textContent = textoOriginal;
    }
  });
}

function initParallax() {
  var els = document.querySelectorAll('[data-mt-parallax]');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function actualizar() {
    els.forEach(function (el) {
      var base = el.dataset.mtBaseTransform || '';
      var rect = el.getBoundingClientRect();
      var centro = rect.top + rect.height / 2 - window.innerHeight / 2;
      var desplazamiento = Math.max(-16, Math.min(16, centro * -0.04));
      el.style.transform = base + ' translateY(' + desplazamiento + 'px)';
    });
    ticking = false;
  }
  function alHacerScroll() {
    if (!ticking) {
      window.requestAnimationFrame(actualizar);
      ticking = true;
    }
  }
  // Solo escuchamos el scroll mientras la imagen está en pantalla; el resto
  // de la página no paga ese coste.
  var escuchando = false;
  new IntersectionObserver(function (entries) {
    var visible = entries.some(function (e) { return e.isIntersecting; });
    if (visible && !escuchando) {
      window.addEventListener('scroll', alHacerScroll, { passive: true });
      escuchando = true;
    } else if (!visible && escuchando) {
      window.removeEventListener('scroll', alHacerScroll);
      escuchando = false;
    }
  }).observe(els[0]);
  actualizar();
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) {
    // Lo que ya está en pantalla al cargar se muestra sin fundido: el
    // precio y el botón de compra nunca deben aparecer "a medias".
    if (el.getBoundingClientRect().top < window.innerHeight * 0.85) {
      el.classList.add('mt-inmediato', 'mt-visible');
      return;
    }
    observer.observe(el);
  });
}

function initBarraCompra() {
  var barra = document.querySelector('[data-mt-barra-compra]');
  var boton = document.querySelector('[data-mt-boton-comprar]');
  if (!barra || !boton) return;
  var botonBarra = barra.querySelector('[data-mt-barra-boton]');
  var precioBarra = barra.querySelector('[data-mt-barra-precio]');
  var precioPrincipal = document.querySelector('[data-mt-precio-actual]');
  var pie = document.querySelector('.footer, footer');
  var botonVisible = true;
  var pieVisible = false;

  function sincronizar() {
    botonBarra.disabled = boton.disabled;
    botonBarra.textContent = boton.textContent.trim();
    var packElegido = document.querySelector('[data-mt-packs] input:checked');
    if (precioBarra && packElegido) precioBarra.textContent = packElegido.dataset.mtPackPrecio;
    else if (precioBarra && precioPrincipal) precioBarra.textContent = precioPrincipal.textContent;
    var mostrar = !botonVisible && !pieVisible;
    barra.classList.toggle('mt-barra-visible', mostrar);
    barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
    botonBarra.tabIndex = mostrar ? 0 : -1;
  }

  // Aparece siempre que el botón principal no esté a la vista (en móvil queda
  // bajo la galería al cargar; al bajar, queda arriba) y se oculta en el pie.
  new IntersectionObserver(function (entries) {
    botonVisible = entries[0].isIntersecting;
    sincronizar();
  }).observe(boton);
  if (pie) {
    new IntersectionObserver(function (entries) {
      pieVisible = entries[0].isIntersecting;
      sincronizar();
    }).observe(pie);
  }
  new MutationObserver(sincronizar).observe(boton, { attributes: true, childList: true, characterData: true, subtree: true });
  botonBarra.addEventListener('click', function () { boton.click(); });
  document.querySelectorAll('[data-mt-packs] input').forEach(function (r) { r.addEventListener('change', sincronizar); });
  sincronizar();
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.mt-faq-pregunta');
    var respuesta = item.querySelector('.mt-faq-respuesta');
    if (!btn || !respuesta) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-abierto');
      item.parentElement.querySelectorAll('.mt-faq-item.mt-abierto').forEach(function (otro) {
        if (otro !== item) {
          otro.classList.remove('mt-abierto');
          otro.querySelector('.mt-faq-respuesta').style.maxHeight = null;
          otro.querySelector('.mt-faq-pregunta').setAttribute('aria-expanded', 'false');
        }
      });
      if (abierto) {
        item.classList.remove('mt-abierto');
        respuesta.style.maxHeight = null;
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('mt-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initContadores() {
  var cifras = document.querySelectorAll('.mt-cifra[data-hasta]');
  if (!cifras.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var hasta = parseFloat(el.dataset.hasta);
        var sufijo = el.dataset.sufijo || '';
        var decimales = el.dataset.decimales ? parseInt(el.dataset.decimales, 10) : 0;
        if (reduce) {
          el.textContent = hasta.toFixed(decimales) + sufijo;
          return;
        }
        var inicio = 0;
        var duracion = 1400;
        var t0 = null;
        function paso(ts) {
          if (!t0) t0 = ts;
          var progreso = Math.min((ts - t0) / duracion, 1);
          var ease = 1 - Math.pow(1 - progreso, 3);
          var valor = inicio + (hasta - inicio) * ease;
          el.textContent = valor.toFixed(decimales) + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  cifras.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-mt-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.dataset.mtSrcGrande || mini.currentSrc || mini.src;
        minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
        mini.classList.add('mt-mini-activa');
        if (principal.getAttribute('src') === src) return;
        // Fundido con leve desenfoque: la foto nueva se carga antes de mostrarse,
        // así nunca se ve un hueco en blanco entre una y otra.
        var nueva = new Image();
        principal.classList.add('mt-cambiando');
        var mostrar = function () {
          principal.src = src;
          requestAnimationFrame(function () { principal.classList.remove('mt-cambiando'); });
        };
        nueva.onload = function () { setTimeout(mostrar, 120); };
        nueva.onerror = mostrar;
        nueva.src = src;
      });
    });
  });
}

function initVariantes() {
  var forms = document.querySelectorAll('[data-mt-form-producto]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    var selects = form.querySelectorAll('[data-mt-opcion]');
    if (!dataEl || !selects.length) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var idInput = form.querySelector('input[name="id"]');
    var boton = form.querySelector('[data-mt-boton-comprar]');
    var precioEl = form.querySelector('[data-mt-precio-actual]');
    var precioTachadoEl = form.querySelector('[data-mt-precio-tachado]');

    function actualizar() {
      var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (precioEl) precioEl.textContent = match.price_formatted;
      if (precioTachadoEl) {
        if (match.compare_at_price_formatted) {
          precioTachadoEl.textContent = match.compare_at_price_formatted;
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (boton) {
        if (match.available) {
          boton.disabled = false;
          boton.textContent = boton.dataset.mtTextoComprar || 'Añadir al carrito';
        } else {
          boton.disabled = true;
          boton.textContent = boton.dataset.mtTextoAgotado || 'Agotado';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}
